import { render, staticRenderFns } from "./CompanyDetailPlanHistory.vue?vue&type=template&id=2be42893&scoped=true&"
import script from "./CompanyDetailPlanHistory.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailPlanHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetailPlanHistory.vue?vue&type=style&index=0&id=2be42893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be42893",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VIcon,VList,VListItem,VListItemContent})
